<template>
    <div id="app" v-cloak>
        <router-view :key="$route.fullPath" />
    </div>
</template>

<script>

    export default {
        name: 'App',
        mounted() {
            // setTimeout(function(){
            //     if(!/Chrome/g.test(navigator.userAgent)&&/Safari/g.test(navigator.userAgent)){
            //         let th=document.getElementsByClassName('gutter')
            //         for (let i = 0; i < th.length; i++) {
            //             console.log(th[i])
            //         }
            //     }
            // },500);
        }
    }

</script>

<style lang="scss" scoped>
/***
/deep/ .el-table{
    padding: 0 20px 10px 0;
}
***/


/deep/ .el-table__fixed { // 左固定列
    height: auto !important;
    bottom: 12px; // 改为自动高度后，设置与父容器的底部距离，高度会动态改变，值可以设置比滚动条的高度稍微大一些,这个根据实际情况改
  }
/deep/ .el-table__fixed-right { // 右固定列
      height: auto !important;
      bottom: 12px; 
    }

/deep/ .el-table__body-wrapper{
       z-index: 2
}		
	
    [v-cloak] {
        display: none;
    }

    #app {
        font-family: "Monospaced Number", "Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    /* 面包屑白色 */
    .el-breadcrumb__inner {
        color: #fff;
    }

    .el-breadcrumb__item:last-child .el-breadcrumb__inner,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
    .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
        color: #fff !important;
    }

    .el-breadcrumb__inner a,
    .el-breadcrumb__inner.is-link {
        color: #fff;
    }

    //    /* 铁路道闸工作台 */
    //         .el-table__expanded-cell[class*=cell]{
    //             padding: 0;
    //         }
    // //    .inSideTable{
    // //         .el-table td{
    // //             padding: 0 !important;
    // //         }
    // //         .el-table--border tr th{
    // //             padding: 0 !important;
    // //         }
    // //    }
    //    .el-table--border tr th{
    //        padding: 0 !important;
    //        height: 15px;
    //    }
    //    .el-table--small td{
    //        padding: 0;
    //    }
    //日报修改
    .zx-pop {
        background: #f5f4f4;
        margin-top: 111px;
    }

    .zx-pop[x-placement^=bottom] .popper__arrow::after {
        border-bottom-color: #f5f4f4;
    }

    .sendCar-border {
        .is-scrolling-none {
            border-bottom: 1px solid;
        }

        .cell {
            font-size: 12px;
            line-height: 13px;
        }
    }

    //拆提放行页面缩小行高
    .chaitifangxingTbale {
        td {
            padding: 0;
        }
    }

    //5月10搜索 收起样式
    .pub-btn {
        float: right;
    }

    .right-icon-order {
        color: #4a62e2;
        display: block;
        float: right;
        margin-top: 7px;
    }

    //5.14账户组快速查看，行高

    .hightRow {
        height: 50px;
    }

    //5.16导航横向滚动条
    .scroll-container {
        .el-scrollbar__thumb {
            width: 80%;
        }
    }

    //5.23
    .fffffff {
        width: 100px !important;

        .el-input {
            width: 100px !important;
        }
    }
    //6.5操作栏按钮点击
    .butCen{
        width: 100%;
        text-align: left;
    }
	

	
</style>



// WEBPACK FOOTER //
// src/App.vue